import { EmptyState } from '@efdigital/ll-xceed-v2/components/application/empty-state';
import { Spinner } from '@efdigital/ll-xceed-v2/components/application/spinner.gts';
import SessionCard from '@efdigital/ll-xceed-v2/components/coaching/coach/session-card.gts';
import type { CoachingCoachSessionsPastModel } from '@efdigital/ll-xceed-v2/routes/coaching/coach/sessions/past';
import CoachService from '@efdigital/ll-xceed-v2/services/coach';
import { toCoachSessionCardItems } from '@efdigital/ll-xceed-v2/utils/coaching/coach-session-card-items';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { Await } from '@warp-drive/ember';
import { pageTitle } from 'ember-page-title';

interface CoachingCoachSessionsPastSignature {
  Args: {
    model: CoachingCoachSessionsPastModel;
    controller: unknown;
  };
}

export default class CoachingCoachSessionsPast extends Component<CoachingCoachSessionsPastSignature> {
  @service declare coach: CoachService;
  @service declare router: RouterService;

  refresh = () => {
    this.router.refresh('coaching.coach.sessions.past');
  };

  <template>
    {{pageTitle "Sessions"}}

    {{#if @model.history.length}}
      <Await @promise={{toCoachSessionCardItems @model.history this.coach}}>
        <:success as |sessions|>
          <div class="d-flex flex-column gap-4">
            {{#each sessions as |item|}}
              <SessionCard
                @session={{item.session}}
                @coach={{@model.coach}}
                @coachee={{item.coachee}}
                @coachingConfig={{item.coachingConfig}}
                @onChanged={{this.refresh}}
              />
            {{/each}}
          </div>
        </:success>
        <:pending>
          <Spinner />
        </:pending>
      </Await>
    {{else}}
      <EmptyState @message="You have no session history." />
    {{/if}}
  </template>
}
